import React, {useEffect, useRef, useState} from 'react';
import ReactMarkdown from 'react-markdown'
import {Col, Container, Row} from "react-bootstrap";
import rehypeRaw from 'rehype-raw'
import {observe} from "../../../helpers";

function InfoSection(props: { mdText?: string, children?: JSX.Element }) {

    const ref = useRef();

    useEffect(() => {
        if(ref.current){
            observe(document.body as HTMLElement);
        }
    }, [props.mdText, ref.current]);

    return (

        <Row ref={ref}>
            <Col>
                <Row>
                    <Col>
                        {props.children}
                    </Col>
                </Row>
                <Row>
                    <Col className={'observer animate_delay5'}>
                        <ReactMarkdown
                            skipHtml={false}
                            rehypePlugins={[rehypeRaw]}
                            children={props.mdText as string}/>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}

export default InfoSection;